<template>
    <div id="toop" class="wrapper">
        <hero></hero>
        <navigation></navigation>

        <main class="main container text-center">
            <introduction></introduction>
            <films></films>
            <theater></theater>
        </main>

        <footer-tag></footer-tag>
    </div>
</template>

<script>
import Vue from 'vue'
import Hero from '@/components/Hero'
import Navigation from '@/components/Navigation'
import Footer from '@/components/Footer'
import Introduction from '@/components/Introduction'
import Films from '@/components/Films'
import Theater from '@/components/Theater'
import vueSmoothScroll from 'vue-smooth-scroll'

Vue.use(vueSmoothScroll)

Vue.component('hero', Hero)
Vue.component('navigation', Navigation)
Vue.component('footer-tag', Footer)

export default {
    name: 'Home',
    components: {Theater, Films, Introduction},
    metaInfo: {
        title: 'Home'
    },
    data () {
        return {
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue